import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_URL || "http://187.127.165.240:5000";

export default function WebinarVerify() {
  const { verifyId } = useParams();
  const [status, setStatus] = useState("loading");
  const [cert, setCert]     = useState(null);

  useEffect(() => {
    // ✅ /webinar/verify/ — separate route
    fetch(`${API_BASE}/webinar/verify/${verifyId}`)
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          setCert(data.certificate);
          setStatus("valid");
        } else {
          setStatus("invalid");
        }
      })
      .catch(() => setStatus("invalid"));
  }, [verifyId]);

  const page = {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Montserrat, sans-serif",
    background: "#f0f4ff",
    padding: 24,
  };

  if (status === "loading") {
    return (
      <div style={page}>
        <div style={{ textAlign: "center" }}>
          <div style={{
            width: 48, height: 48,
            border: "4px solid #e0e7ff",
            borderTop: "4px solid #4f46e5",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
            margin: "0 auto 16px",
          }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          <p style={{ color: "#4f46e5", fontWeight: 700 }}>Verifying...</p>
        </div>
      </div>
    );
  }

  if (status === "invalid") {
    return (
      <div style={page}>
        <div style={{
          background: "#fff", borderRadius: 20,
          padding: "40px 36px", maxWidth: 400, width: "100%",
          boxShadow: "0 4px 24px rgba(0,0,0,0.10)", textAlign: "center",
        }}>
          <div style={{ fontSize: 56, marginBottom: 12 }}>❌</div>
          <h2 style={{ color: "#dc2626", fontWeight: 800, margin: "0 0 10px" }}>
            Invalid Certificate
          </h2>
          <p style={{ color: "#64748b", fontSize: 14, lineHeight: 1.6, margin: 0 }}>
            This webinar certificate is not valid.<br />
            Please contact the administrator.
          </p>
        </div>
      </div>
    );
  }

  // ── Valid ──
  const row = (label, value) => (
    <div style={{
      display: "flex", justifyContent: "space-between",
      padding: "10px 0", borderBottom: "1px solid #f1f5f9",
      gap: 12, flexWrap: "wrap",
    }}>
      <span style={{ fontSize: 13, color: "#64748b", fontWeight: 600 }}>{label}</span>
      <span style={{ fontSize: 14, color: "#1e2736", fontWeight: 700, textAlign: "right" }}>
        {value || "—"}
      </span>
    </div>
  );

  return (
    <div style={page}>
      <div style={{
        background: "#fff", borderRadius: 20,
        padding: "40px 36px", maxWidth: 420, width: "100%",
        boxShadow: "0 4px 24px rgba(0,0,0,0.10)",
      }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{
            width: 72, height: 72, background: "#dcfce7",
            borderRadius: "50%", fontSize: 36, margin: "0 auto 14px",
            display: "flex", alignItems: "center", justifyContent: "center",
          }}>✅</div>
          <h2 style={{ color: "#059669", fontWeight: 800, margin: "0 0 4px", fontSize: 20 }}>
            Genuine Webinar Certificate
          </h2>
          <p style={{ color: "#64748b", fontSize: 13, margin: 0 }}>
            Uncodemy Edutech Pvt. Ltd.
          </p>
        </div>

        {/* Details */}
        <div style={{
          background: "#f8fafc", borderRadius: 12,
          padding: "4px 16px", border: "1px solid #e2e8f0",
        }}>
          {row("Name",       cert.name)}
          {row("Course",     cert.course)}
          {row("Duration",   cert.duration)}
          {row("Date",       cert.completionDate)}
          {row("Issued On",  cert.issuedOn
            ? new Date(cert.issuedOn).toLocaleDateString("en-IN")
            : "—"
          )}
        </div>

        {/* Badge */}
        <div style={{
          marginTop: 20, textAlign: "center",
          background: "#eff6ff", borderRadius: 10,
          padding: "10px 16px", border: "1px solid #bfdbfe",
        }}>
          <p style={{ fontSize: 12, color: "#1d4ed8", fontWeight: 700, margin: 0 }}>
            🔒 Verified by Uncodemy Secure System
          </p>
        </div>
      </div>
    </div>
  );
}